var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWallet(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.5001 8.50049V5.00036C18.5001 4.66163 18.1704 4.42092 17.8478 4.52414L5.34778 8.52321C5.13175 8.59232 4.99533 8.79453 5.00012 9.01031V19.5005C5.00012 19.7766 5.22398 20.0005 5.50012 20.0005H20.0001C20.2763 20.0005 20.5001 19.7766 20.5001 19.5005V13.8872V9.00049C20.5001 8.72435 20.2763 8.50049 20.0001 8.50049H18.5001ZM17.5001 8.50049V5.68529L8.70059 8.50049H17.5001ZM19.5001 13.3872H18.0001C17.724 13.3872 17.5001 13.6111 17.5001 13.8872C17.5001 14.1633 17.724 14.3872 18.0001 14.3872H19.5001V19.0005H6.00012V9.50049H19.5001V13.3872Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.a4c19ff524b5fa3649fc3ff77833377d.svg";
export { ForwardRef as ReactComponent };